import React, {ReactElement, useState} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

import {useShippingProtection} from '../../hooks/shippingProtection/useShippingProtection';

import {ShippingProtectionModal} from './shippingProtectionModal/shippingProtectionModal';
import {ToggleShippingProtectionConnected} from './toggleShippingProtection/toggleShippingProtection';

import s from './shippingProtection.scss';

/**
 * Shipping protection component for checkout
 * @returns {React.ReactElement} - Shipping Protection
 */
export const ShippingProtection = (): ReactElement | null => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const [isSheetVisible, setIsSheetVisible] = useState(false);
    const {isEligible} = useShippingProtection();

    const modalHandler = (isOpen: boolean) => {
        sendDesktopAnalyticsPerSession({
            event: CHECKOUT_DELIVERY_STEP,
            label: {
                message: isOpen
                    ? `Shipping Protection - Learn More`
                    : 'Shipping Protection - Learn More Closed',
            },
        });
        setIsSheetVisible(isOpen);
    };

    if (!isEligible) return null;

    return (
        <>
            <p className={classNames(s.protectionTitle, {[s.protectionTitleFacelift]: isFacelift})}>
                Shipping protection
            </p>
            <div className={classNames(s.container, {[s.containerFacelift]: isFacelift})}>
                <ToggleShippingProtectionConnected modalHandler={() => modalHandler(true)} />
                <ShippingProtectionModal
                    closePopup={() => modalHandler(false)}
                    isOpen={isSheetVisible}
                />
            </div>
        </>
    );
};
